module.exports = __webpack_public_path__ + "static/media/chatlogobutton.fbade9d0.jpg";